export default __webpack_public_path__ + "static/solid-0c0d5a4714d88aadd2ca14cf05e9a371.svg";